export const handler = (el, e) => {
  const target = document.querySelector(el.getAttribute('data-scroll-target'));
  target.scrollIntoView();
};
